import type { UserSummaryDto, UserRole, OwnerEntity } from '@bhops/shared';
import { apiClient } from './client';

export interface CreateUserBody {
  email: string;
  password: string;
  displayName: string;
  role?: UserRole;
  ownerEntity: OwnerEntity;
}

export interface UpdateUserBody {
  displayName?: string;
  role?: UserRole;
  // FB §1 — 사용자 편집에서 법인(소속) 변경.
  ownerEntity?: OwnerEntity;
  disabled?: boolean;
}

export const usersApi = {
  async list(): Promise<UserSummaryDto[]> {
    const { data } = await apiClient.get<UserSummaryDto[]>('/users');
    return data;
  },
  async get(id: string): Promise<UserSummaryDto> {
    const { data } = await apiClient.get<UserSummaryDto>(`/users/${id}`);
    return data;
  },
  async create(body: CreateUserBody): Promise<UserSummaryDto> {
    const { data } = await apiClient.post<UserSummaryDto>('/users', body);
    return data;
  },
  async update(id: string, body: UpdateUserBody): Promise<UserSummaryDto> {
    const { data } = await apiClient.patch<UserSummaryDto>(`/users/${id}`, body);
    return data;
  },
  // FB §1 — soft-delete. 서버가 deletedAt 스탬프 + 세션 revoke 수행.
  async remove(id: string): Promise<{ id: string; deletedAt: string }> {
    const { data } = await apiClient.delete<{ id: string; deletedAt: string }>(`/users/${id}`);
    return data;
  },
  async resetPassword(id: string, password: string): Promise<void> {
    await apiClient.post(`/users/${id}/reset-password`, { password });
  },
};
